import React from 'react';
import { isEmpty } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
// import PropTypes from 'prop-types';

import {
  Box,
  Divider,
  Fab,
  FormControlLabel,
  Grid,
  IconButton,
  Switch,
  Typography
} from '@mui/material';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useTimeStore from '../ZustandProvider';
import Loading from '../Loading';
import NewWMSLayerComponent from '../NewWMSLayerComponent';

const SentinelComponent = props => {
  const dataToSend = useTimeStore(state => state.dataToSend);
  const [firstAnswer, setFirstAnswer] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [openNewLayer, setOpenNewLayer] = React.useState(false);
  const [quality, setQuality] = React.useState(false);
  const [secondAnswer, setSecondAnswer] = React.useState({});

  const firstCallToServer = async () => {
    if (!isEmpty(dataToSend)) {
      if (dataToSend.length === 2) {
        try {
          const response = await fetch(
            'https://sd1.ipsgeoprocesing.ipsilum.com/MG/sentinel/exec_sentinel',
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                disk: '/home/data3/master_folder',
                point: dataToSend,
                hr: quality
              }),
              mode: 'cors',
              credentials: 'omit',
              referrerPolicy: 'no-referrer'
            }
          );
          const answer = await response.json();
          setIsLoading(false);
          setFirstAnswer(answer);
        } catch (error) {
          console.error('Error:', error);
        }
      } else {
        Bert.alert('Selecciona otro punto del mapa', 'warning');
      }
    } else {
      Bert.alert('Selecciona primero una zona en el mapa', 'warning');
    }
  };

  const secondCallToServer = async () => {
    try {
      const response = await fetch(
        'https://sd1.ipsgeoprocesing.ipsilum.com/MG/lidar/exec_process_files',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            inputFile: firstAnswer.path,
            execName: 'Geoserver',
            dataBase: {
              url: 'https://geoserver.ipsilum.com/geoserver',
              username: 'admin',
              password: 'geoserver',
              workspace: 'sentinel'
            }
          }),
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        }
      );
      const answer = await response.json();
      setIsLoading(false);
      if (answer.link) {
        setSecondAnswer(answer.link);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <Grid container spacing={1} mt={1} mb={4} alignItems="stretch">
        <Box
          component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            width: '100%',
            mb: 2
          }}
          noValidate
          autoComplete="off"
        >
          {/* {isEmpty(dataToSend) && (
            <Typography variant="h6" fontWeight="arial">
              Seleccina dos puntos en el mapa para dibujar un rectángulo
            </Typography>
          )} */}
          <FormControlLabel
            control={<Switch checked={quality} onChange={() => setQuality(!quality)} />}
            label={quality ? 'Alta resolución' : 'Resolución normal'}
          />
          <Fab
            onClick={() => {
              setIsLoading(true);
              firstCallToServer();
            }}
            size="small"
            style={{
              color: 'white',
              backgroundColor: '#2A3F90',
              boxShadow: 'none',
              justifyContent: 'flex-start'
            }}
            variant="extended"
          >
            Cargar geometría
          </Fab>
        </Box>
        {!isEmpty(firstAnswer) && (
          <>
            <Box
              component="form"
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'space-evenly',
                mb: 2
              }}
              noValidate
              autoComplete="off"
            >
              <Fab
                onClick={() => window.open(firstAnswer.link, '_blank')}
                size="small"
                style={{
                  color: 'white',
                  backgroundColor: '#2A3F90',
                  boxShadow: 'none',
                  justifyContent: 'flex-start'
                }}
                variant="extended"
              >
                Descargar
              </Fab>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                width: '100%'
                // borderBottom: '1px solid grey', // Línea hasta el final
                // paddingBottom: 1 // Espacio entre la línea y los elementos
              }}
            >
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <IconButton
                    onClick={() => {
                      setIsLoading(true);
                      secondCallToServer();
                      setOpenNewLayer(!openNewLayer);
                    }}
                  >
                    {openNewLayer === true ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                  </IconButton>
                </Grid>
                <Grid item>
                  <Typography variant="body1">Crear Layer WMS</Typography>
                </Grid>
                <Grid item xs>
                  <Divider sx={{ height: 1, backgroundColor: 'grey' }} />
                </Grid>
              </Grid>
            </Box>
            <Box
              component="form"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'space-evenly',
                mb: 2,
                position: 'relative'
              }}
              noValidate
              autoComplete="off"
            >
              {!isEmpty(secondAnswer) && (
                <NewWMSLayerComponent
                  url={secondAnswer}
                  setOpenNewLayer={setOpenNewLayer}
                  {...props}
                />
              )}
            </Box>
          </>
        )}
        {isLoading === true && <Loading />}
      </Grid>
    </>
  );
};
export default SentinelComponent;

SentinelComponent.defaultProps = {};
SentinelComponent.propTypes = {};
